import { MichelinLogo } from 'utilities/createTheme/logos/MichelinLogo';

export const getLogoMichelin = () => ({
  primary: MichelinLogo.DEFAULT,
});
